<!--单位信息模块-->
<template>
  <div class="workStateBody usePowerUnitDiv">
    <div class="topLeftTitleContent">运行情况</div>
    <div class="workStateContent bodyBorder">
      <div class="workStateLeft">
        <div class="workStateLeftTop">
          <p>安全运行:<span style="letter-spacing: 0rem;min-width: 30px;display: inline-block;text-align: center;">
              {{safetyDate}}
            </span>天</p>
          <p>服务到期:<span style="letter-spacing: 0rem;min-width: 30px;display: inline-block;text-align: center;">
              {{haveDate}}
            </span>天</p>
        </div>
        <div class="workStateLeftBottom">
          <div class=" usePowerUnitBlock" style="width: 97%; height: 72px;">
            <p class="usePowerUnitBoxTitle">总告警数</p>
            <p class="usePowerUnitBoxInfo special">{{eventObj.allCount}}</p>
          </div>
          <div class=" usePowerUnitBlock" style="width: 47%;margin-top: .05rem;">
            <p class="usePowerUnitBoxTitle">预警</p>
            <p class="usePowerUnitBoxInfo" style="height: 20px;line-height: 20px;">{{eventObj.allYjCount}}</p>
          </div>
          <div class=" usePowerUnitBlock" style="width: 47%;margin-top: .05rem;margin-left: .05rem;">
            <p class="usePowerUnitBoxTitle">告警</p>
            <p class="usePowerUnitBoxInfo" style="height: 20px;line-height: 20px;">{{eventObj.allGjCount}}</p>
          </div>
        </div>
      </div>
      <div class="workStateRigth">
        <div class="workStatebuttonLine">
          <div class="workStatebuttonLineChild workStatebuttonLineChildValue">
            <p>{{eventObj.monthWclCount}}</p>
            <p>{{eventObj.monthAllCount}}</p>
          </div>
          <div class="workStatebuttonLineChild workStatebuttonLineChildKey">
            <p>未确认告警</p>
            <p>本月告警数</p>
          </div>
          <div class="workStatebuttonLineChild">
            <div style="width: 50%;background-color: #FF9900;height: .15rem;"></div>
            <div style="width: 50%;background-color: #DDDDDD;height: .15rem;"></div>
          </div>
        </div>
        <div class="workStateRigthBottom">
          <div class=" usePowerUnitBlock" style="width: 25%;">
            <p class="usePowerUnitBoxTitle">上月同期</p>
            <p class="usePowerUnitBoxInfo">{{eventObj.lastMonthAllCount}}</p>
          </div>
          <div class=" usePowerUnitBlock" style="width: 20%;">
            <p class="usePowerUnitBoxTitle">环比增长</p>
            <p class="usePowerUnitBoxInfo">{{eventObj.lastMonthAllCount2}}</p>
          </div>
          <div class=" usePowerUnitBlock" style="width: 20%;">
            <p class="usePowerUnitBoxTitle">去年同期</p>
            <p class="usePowerUnitBoxInfo">{{eventObj.lastYearMonthAllCount}}</p>
          </div>
          <div class=" usePowerUnitBlock" style="width: 20%;">
            <p class="usePowerUnitBoxTitle">同比增长</p>
            <p class="usePowerUnitBoxInfo">{{eventObj.lastYearMonthAllCount2}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    components: {},
    props: [],
    data () {
      return {
        saveUnitInfo: {
          checkCompleted: 0,
          checkPlan: 0,
        },
        noAlarm: 0,
        alarm: 0,
        unConfirmedAlarm: 0, //未确认告警
        earlyWarning: 0,
        monthEvent: 0,
        lastYearMonthEvent: 0, //上年本月
        lastMonthEvent: 0, //上月事件
        eventObj: {
          "monthWclCount": 18,
          "monthAllCount": 22,
          "allGjCount": 2428,
          "lastMonthAllCount%": "318.18%",
          "allCount": 2827,
          "lastMonthAllCount": 70,
          "lastYearMonthAllCount%": "2172.73%",
          "lastYearMonthAllCount": 478,
          "allYjCount": 399,
          "lastMonthAllCount2": "318.18%",
          "lastYearMonthAllCount2": "2172.73%"
        }
      }
    },
    created () {},
    mounted () {
      debugPage=this
      addNewTask('refreshWorkStateNoWork',0,5*60*1000,-1,() => {
        this.initData()
      })
      this.eventListData()
    },
    destroyed () {
      removeTask('refreshWorkStateNoWork')
    },
    computed: {
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getOnYear () {
        //同比
        if(this.lastYearMonthEvent!=0) {
          return ((this.monthEvent-this.lastYearMonthEvent)*100/this.lastYearMonthEvent).toFixed(2)
        }
        return 0
      },
      ringRatio () {
        if(this.lastMonthEvent!=0) {
          return parseFloat(((this.monthEvent-this.lastMonthEvent)*100/this.lastMonthEvent).toFixed(2))
        }
        return 0
      },
      safetyDate () {
        return Math.floor((Date.now()-this.nowUnit.joinTime)/(24*3600*1000))
      },
      haveDate () {
        return Math.floor((this.nowUnit.expirationTime-Date.now())/(24*3600*1000))
      }

    },
    watch: {
      saveUnitInfo (nv,ov) {},
      nowUnit (nv,ov) {
        this.initData()
        this.eventListData()
      }
    },
    methods: {
      initData () {
        if(isempty(this.nowUnit)) {
          setTimeout(() => {
            this.initData()
          },100)
          return
        }
        this.$api.unitApi.getUnitInfo(this.nowUnit.id,respon => {
          if(respon!=null) {
            this.saveUnitInfo=respon
          } else {
            this.saveUnitInfo={
              checkCompleted: 0,
              checkPlan: 0,
            }
          }
        })
      },
      isemptyUndefined (data) {
        if(data==undefined) {
          return 0
        }
        return data
      },
      eventListData () {
        this.$api.eventApi.countUnitEvents(this.nowUnit.id,respon => {
          if(respon=="正在获取中。。。请稍后") {
            setTimeout(() => {
              this.$api.eventApi.countUnitEvents(this.nowUnit.id,respon => {
                this.eventObj=respon
                this.eventObj.lastMonthAllCount2=respon["lastMonthAllCount%"]
                this.eventObj.lastYearMonthAllCount2=respon["lastYearMonthAllCount%"]
              })
            },7000);
          } else {
            this.eventObj=respon
            this.eventObj.lastMonthAllCount2=respon["lastMonthAllCount%"]
            this.eventObj.lastYearMonthAllCount2=respon["lastYearMonthAllCount%"]
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import url("../../../components/css/usePowerUnit.css");

  .workStateBody {
    height: 274px;
  }

  .workStateBody .workStateContent {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: calc(100% - 31px);
  }

  .workStateBody .workStateLeft {
    width: 20%;
    height: 90%;
  }

  .workStateBody .workStateLeft .workStateLeftTop {
    width: 100%;
    height: 38%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .workStateBody .workStateLeft .workStateLeftTop p {
    color: #999999;
    letter-spacing: .01rem;
    line-height: .3rem;
  }

  .workStateBody .workStateLeft .workStateLeftBottom {
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 62%;
    justify-content: center;
  }

  .workStateBody .workStateRigthBottom {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .workStateBody .workStateRigth {
    width: 70%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .workStateBody .workStateRigth .workStatebuttonLine {
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .workStateBody .workStateRigth .workStatebuttonLine .workStatebuttonLineChild {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }

  .workStateBody .workStateRigth .workStatebuttonLine .workStatebuttonLineChildValue span {
    color: #FF3300;
    font-size: 20px;
    font-weight: 600;
  }

  .workStateBody .workStateRigth .workStateRigthBottom {
    width: calc(100% - 10px);
    height: 50%;
    display: flex;
    align-items: center;
    padding: 0 4px;
  }

  .workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomNone {
    height: 81%;
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background: none;
    border: 1px solid #ccc;
  }

  .workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomTwo {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 78%;
    justify-content: space-around;
    height: 90%;
  }

  .workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomTwo .workStateRigthBottomTwoChild {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    height: 40%;
    background: none;
    border: 1px solid #ccc;
    width: 100%;
  }
</style>